export enum PrintStatus {
    loadinStart,
    loadingEnd,
    printDialogClose
  }
  